function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import { Image } from "../../Image/Image/Image";
import { HeadingText } from "../../Text/HeadingText/HeadingText";
import { Text } from "../../Text/Text/Text";
import { Breakpoint } from "../../Responsive/Breakpoint/Breakpoint";
import { Theme } from "../../Background/Theme/Theme";
import { Icon } from "../../Icon/Icon/Icon";
import classnames from 'classnames';
import { Navigation, Pagination, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.min.css';
import styles from "./SectionSix.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SectionSix = function SectionSix(_ref) {
  var heading = _ref.heading,
    slides = _ref.slides,
    footerText = _ref.footerText;
  return /*#__PURE__*/_jsx("div", {
    className: styles.sectionSix,
    children: /*#__PURE__*/_jsx(Theme, {
      theme: "darkBackground",
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.inner,
        children: [heading && /*#__PURE__*/_jsx(HeadingText, {
          richText: true,
          align: "left",
          className: styles.heading,
          typog: heading.typog,
          ariaLevel: heading.ariaLevel,
          children: heading.text
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.swiper,
          children: [/*#__PURE__*/_jsx(Swiper, {
            modules: [Navigation, Pagination, A11y],
            pagination: {
              clickable: true,
              el: '.swiper-pagination',
              renderBullet: function renderBullet(index, className) {
                return "<span class=\"".concat(classnames(className, styles.bullet), "\"></span>");
              },
              bulletActiveClass: classnames('swiper-pagination-bullet-active', styles.bulletActive)
            },
            navigation: {
              nextEl: '.swiper-next',
              prevEl: '.swiper-previous'
            },
            loop: true,
            children: slides === null || slides === void 0 ? void 0 : slides.map(function (slide, index) {
              return /*#__PURE__*/_jsx(SwiperSlide, {
                className: styles.slide,
                children: /*#__PURE__*/_jsxs("div", {
                  className: styles.columns,
                  children: [/*#__PURE__*/_jsxs("div", {
                    className: styles.left,
                    children: [/*#__PURE__*/_jsx(Image, _objectSpread({
                      className: classnames(styles.image, styles.mobile)
                    }, slide.image.mobile)), /*#__PURE__*/_jsx(Image, _objectSpread({
                      className: classnames(styles.image, styles.desktop)
                    }, slide.image.desktop))]
                  }), /*#__PURE__*/_jsx("div", {
                    className: styles.right,
                    children: /*#__PURE__*/_jsx("div", {
                      className: styles.details,
                      children: /*#__PURE__*/_jsxs("div", {
                        className: styles.detailsInner,
                        children: [/*#__PURE__*/_jsx(Text, {
                          richText: true,
                          className: styles.quote,
                          typog: "bodycopyExtraLarge",
                          children: slide.quote
                        }), /*#__PURE__*/_jsxs(Breakpoint, {
                          breakpoint: "small",
                          children: [/*#__PURE__*/_jsx(Image, _objectSpread({
                            className: styles.signature
                          }, slide.signature.mobile)), /*#__PURE__*/_jsx(Image, _objectSpread({
                            className: styles.signature
                          }, slide.signature.desktop))]
                        }), /*#__PURE__*/_jsxs("div", {
                          className: styles.nameWrapper,
                          children: [/*#__PURE__*/_jsx(Text, {
                            richText: true,
                            className: styles.name,
                            typog: "bodycopyLarge",
                            children: slide.name
                          }), /*#__PURE__*/_jsx(Text, {
                            richText: true,
                            className: styles.tagline,
                            typog: "bodycopyLarge",
                            children: slide.tagline
                          })]
                        })]
                      })
                    })
                  })]
                })
              }, "slide-".concat(index));
            })
          }), /*#__PURE__*/_jsx("div", {
            className: styles.controlsWrapper,
            children: /*#__PURE__*/_jsxs("div", {
              className: styles.controls,
              children: [/*#__PURE__*/_jsx("div", {
                className: classnames('swiper-previous', styles.prev),
                children: /*#__PURE__*/_jsx(Icon, {
                  type: "carousel-left",
                  className: styles.icon
                })
              }), /*#__PURE__*/_jsx("div", {
                className: classnames('swiper-pagination', styles.pagination)
              }), /*#__PURE__*/_jsx("div", {
                className: classnames('swiper-next', styles.next),
                children: /*#__PURE__*/_jsx(Icon, {
                  type: "carousel-right",
                  className: styles.icon
                })
              })]
            })
          })]
        }), footerText && /*#__PURE__*/_jsx("div", {
          className: styles.footer,
          children: /*#__PURE__*/_jsx(Text, {
            richText: true,
            align: "center",
            typog: "bodycopyExtraSmall",
            className: styles.footerText,
            children: footerText
          })
        })]
      })
    })
  });
};